// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","content":"App_content__1Wt3K"};